import { SelectField } from 'iq-blueberry'
import useSplitDateMonth from './hook'

import './style.styl'


const SplitDateMonth = ({ 
  label,
  slug,
  isRequired,
  maximumMonthsOld = 0,
  maximumYearsOld = 0,
  monthsOnReverse = false,
  yearsOnReverse = true,
  startOnCurrentYear = true,
  payload,
  modifyPayloadKeys
}) => {
  const {
    selectedMonth,
    selectedYear,
    onChangeMonth,
    onChangeYear,
    monthsList,
    yearsList,
    isValidMonth,
    hasYearsToSelect,
  } = useSplitDateMonth({ 
    maximumMonthsOld,
    maximumYearsOld,
    monthsOnReverse,
    yearsOnReverse,
    startOnCurrentYear,
    slug,
    payload,
    modifyPayloadKeys
  })
  
  return (
    <div className="split-date">
      <label className="iq-field-base__label" htmlFor={`${slug}-month`}>
        {label}
        {isRequired && 
          <span className="iq-field-base__required"> *</span>
        }
      </label>
      <SelectField
        invalid={!isValidMonth}
        required={isRequired}
        onChange={onChangeMonth}
        name={`${slug}-month`}
        value={selectedMonth}
        options={monthsList}
        placeholder={'Mês'}
      />
      <SelectField
        disabled={!hasYearsToSelect}
        required={isRequired}
        onChange={onChangeYear}
        name={`${slug}-year`}
        value={selectedYear}
        options={yearsList}
        placeholder={'Ano'}
      />
    </div>
  )
}

export default SplitDateMonth
